const students = [
  {
    id: 1,
    classroom: "9-B", 
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "B-VE",
    dateOfBirth: "2002-05-28",
    region: "Andhra Pradesh",
    district: "Ananthapur",
    circuit: "A Narayanapuram",
    address: "location somewhere",
    address: "location somewhere",
    status: false,
  },
  {
    id: 2,
    classroom: "2-B",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "B+VE",
    dateOfBirth: "2002-05-28",
    region: "Telangana",
    district: "Koderma",
    circuit: "Madhopur",
    address: "location somewhere",
    status: true,
  },
  {
    id: 3,
    classroom: "1-A",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "A+VE",
    dateOfBirth: "2002-05-28",
    region: "Jharkhand",
    district: "Koderma",
    circuit: "Mahugain",
    address: "location somewhere",
    status: true,
  },
  {
    id: 4,
    classroom: "11-A",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "A+VE",
    dateOfBirth: "2002-05-28",
    region: "Telangana",
    district: "Koderma",
    circuit: "Madhopur",
    address: "location somewhere",
    status: false,
  },
  {
    id: 5,
    classroom: "10-C",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "O+VE",
    dateOfBirth: "2002-05-28",
    region: "Andhra Pradesh",
    district: "Ananthapur",
    circuit: "A Narayanapuram",
    address: "location somewhere",
    status: true,
  },
  {
    id: 6,
    classroom: "6-C",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "O-VE",
    dateOfBirth: "2002-05-28",
    region: "Jharkhand",
    district: "Koderma",
    circuit: "Mahugain",
    address: "location somewhere",
    status: false,
  },
  {
    id: 7,
    classroom: "3-A",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "AB+VE",
    dateOfBirth: "2002-05-28",
    region: "Gujarat",
    district: "Surat",
    circuit: "Adajan",
    address: "location somewhere",
    status: true,
  },
  {
    id: 8,
    classroom: "4-A",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "AB-VE",
    dateOfBirth: "2002-05-28",
    region: "Gujarat",
    district: "Surat",
    circuit: "Varachha",
    address: "location somewhere",
    status: false,
  },
  {
    id: 9,
    classroom: "12-D",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "O-VE",
    dateOfBirth: "2002-05-28",
    region: "Gujarat",
    district: "Surat",
    circuit: "Adajan",
    address: "location somewhere",
    status: true,
  },
  {
    id: 10,
    classroom: "8-C",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "O-VE",
    dateOfBirth: "2002-05-28",
    region: "Gujarat",
    district: "Surat",
    circuit: "Varachha",
    address: "location somewhere",
    status: true,
  },
  {
    id: 11,
    classroom: "5-C",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "O+VE",
    dateOfBirth: "2002-05-28",
    region: "Jharkhand",
    district: "Hazaribag",
    circuit: "Maheshra",
    address: "location somewhere",
    status: false,
  },
  {
    id: 12,
    classroom: "9-B",
    fullName: "Neal Matthews",
    parentName: "Parent Name",
    phoneNumber: "9879879898",
    altPhoneNumber: "9879879898",
    email: "demo@gmail.com",
    profilePic: "profile_pic.png",
    bloodGroup: "B+ve",
    dateOfBirth: "2002-05-28",
    region: "Assam",
    district: "Karimganj",
    circuit: "Adarkona",
    address: "location somewhere",
    status: true,
  },
]

export { students }
